export const Box = ({
  children,
  padding = 4,
  textAlign = "justify",
  bgColor = "gray-50 dark:bg-gray-800",
  borderColor = "gray-200 dark:border-gray-700",
  className = "",
  isActive = true,
  cursor="default",
  ...args
}) => {
    const isActiveClass = isActive  ? "opacity-100 blur-none"
                    : "blur-sm opacity-50"
  return (
    <div
      {...args}
      className={`p-${padding} text-${textAlign} grid grid-cols-1 bg-${bgColor} lg:border border-${borderColor} lg:rounded-md lg:shadow-sm ${className} hover:blur-none ` +
       `${isActiveClass} cursor-${cursor}`}
    >
      {children}
    </div>
  );
};
